import type { AtmosphereType } from "../../../../utils/types/AtmosphereType";
import type { CompareSpecsGradeType, CompareSpecsType } from "../../../../utils/types/CompareSpecsType";
import type { useGetCompareGradesReturnType } from "./compareHooks";

export const MAX_DEFAULT_PACK_FEATURES = 3;

export const MAX_DEFAULT_FEATURES = 4;
export const MAX_DEFAULT_SHARED_FEATURES = 4;
export const MAX_DEFAULT_UNIQUE_FEATURES = 4;

export const isSingle = (grades: useGetCompareGradesReturnType): boolean => typeof grades[1] === "undefined";

export const getDetailedGrade = (
    compareSpecsGrades: CompareSpecsType,
    grade?: AtmosphereType,
): CompareSpecsGradeType | undefined => {
    return compareSpecsGrades.find(({ id }) => grade?.id === id);
};
